import * as yup from 'yup';

export const ManutencaoPlanoBSchema = yup.object({
  solicitacao: yup.bool().oneOf([true], 'Atenção, Clique em Solicitação'),
});

export const ManutencaoPlanoBInitialValues = {
  solicitacao: false,
};
